import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ActivationModalComponent } from '../activation-modal/activation-modal.component';

@Injectable()
export class ActivationModalService {
	constructor(private dialog: MatDialog) {}

	openActivationModal(email: string): void {
		const dialogRef = this.dialog.open(ActivationModalComponent, {
			width: '350px',
			data: { email }
		});
/*
		dialogRef.afterClosed().subscribe(() => {
			console.log('The dialog was closed');
		});*/
	}
}
